var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 47,
    viewBox: "0 0 62 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6403 29.2324L34.3653 23.5284L29.9433 16.4814H50.5173L54.9633 9.67342H17.8673L30.6403 29.2324Z",
    fill: "#1EBFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.00101471L30.64 46.916L44.281 26.032L40.252 19.869L30.64 34.592L12.454 6.74302H56.878L61.28 0.00101471H0Z",
    fill: "#1EBFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetLogo);
export default __webpack_public_path__ + "static/media/fleet_logo.5b2388dea9839365d2587d7972d744c6.svg";
export { ForwardRef as ReactComponent };